export class PatientMinimal {
  fullName = '';

  id = 0;

  constructor(obj: any) {
    Object.assign(this, obj);
  }

  get nameWithId() {
    return `${this.fullName} (${this.id})`;
  }
}

export default PatientMinimal;
